
import React, { useState, useEffect } from 'react';
import { Modal, Button, ListGroup, Badge, Form } from 'react-bootstrap';
import { authFetch } from '../utils/authFetch';

export default function SeriiVanzareModal({ show, onHide, line, onSave, readOnly }) {
    const [disponibile, setDisponibile] = useState([]);
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(false);

    const bxpart_id = line?.bxpart_id;
    const qty = Number(line?.qty || line?.bxcantitate || 0);

    useEffect(() => {
        if (show && bxpart_id) {
            setSelected(line?.serii || []);
            setLoading(true);
            authFetch('/serii/disponibile/' + bxpart_id)
                .then(data => setDisponibile(data || []))
                .catch(console.error)
                .finally(() => setLoading(false));
        }
    }, [show, bxpart_id, line]);

    const handleToggle = (serie_str) => {
        if (selected.includes(serie_str)) {
            setSelected(selected.filter(s => s !== serie_str));
        } else {
            if (selected.length < qty) {
                setSelected([...selected, serie_str]);
            }
        }
    };

    const handleSave = () => {
        onSave(selected);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Selecteaza Serii (Vnzare)</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <strong>Cantitate de vndut:</strong> {qty}
                    <br />
                    <strong>Serii selectate:</strong> <Badge bg={selected.length === qty ? 'success' : 'warning'}>{selected.length} / {qty}</Badge>
                </div>

                {loading ? <p>Se ncarca seriile...</p> : (
                    <ListGroup style={{maxHeight: 300, overflowY: 'auto'}}>
                        {disponibile.length === 0 ? <p className="text-muted">Nu exista serii disponibile n stoc pentru acest articol.</p> : null}
                        {disponibile.map((item) => (
                            <ListGroup.Item 
                                key={item.id} 
                                action 
                                onClick={() => !readOnly && handleToggle(item.serie)}
                                active={selected.includes(item.serie)}
                            >
                                <Form.Check 
                                    type="checkbox"
                                    label={item.serie}
                                    checked={selected.includes(item.serie)}
                                    onChange={() => {}} 
                                />
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>nchide</Button>
                {!readOnly && <Button variant="primary" onClick={handleSave} disabled={selected.length > 0 && selected.length !== qty}>Salveaza</Button>}
            </Modal.Footer>
        </Modal>
    );
}

